// extracted by mini-css-extract-plugin
module.exports = {"wrapperWithBanner":"_1Vf9BdeodzohZEWFTtwWrS","wrapperFullSiteWithReminder":"_1dfTVE5xTeIrjniJV1dqs1"};